import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React, { useEffect } from 'react';

import { InputMoney } from '../../../../../../../../../components/InputMoney';
import { ResponsiveSuccessIconButton } from '../../../../../../../../../components/ResponsiveSuccessIconButton';
import { TableContentItemText } from '../../../../../../../../../components/TableContent';
import { useDirectTreasuryAssetController } from '../../../../../hooks/products/DirectTreasury';
import { LateralBar } from '../../../components/LateralBar';

import { DirectTreasuryItemSelectedTypes } from '.';

export const DirectTreasuryItemSelectedTablet: React.FC<DirectTreasuryItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
}) => {
  const id = offer.productIdNormalized;
  const {
    control,
    amountItem,
    currentValue,
    currentValueFormatted,
    handleChangeAmountItem,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
  } = useDirectTreasuryAssetController(offer);

  useEffect(() => {
    if (offer.orderValue === currentValue || !currentValue) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderValue: currentValue || 0,
      orderQuantity: amountItem || 0.01,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  return (
    <Box p="inline.xxs">
      <LateralBar
        backgroundColor={Color['product.rf']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack flex={1} space="inline.xxxs">
        <HStack flex={1} justifyContent="space-between">
          <UI.ListItem testId="selected-product-name" title="Produto" stackProps={{ maxW: '1/4' }}>
            <TableContentItemText>{offer.productNameNormalized}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-application-date" title="Data da aplicação">
            <TableContentItemText>
              {Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy')}
            </TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-application-in" title="Aplicação em">
            <TableContentItemText>{offer.settlementDateFormattedNormalized}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-minimum-investment" title="Investimento mínimo">
            <TableContentItemText>
              {Utils.Mask.Money(offer.minimumApplication)}
            </TableContentItemText>
          </UI.ListItem>
        </HStack>
        <HStack flex={1} alignItems="flex-end" justifyContent="space-between">
          <UI.ListItem
            testId="selected-product-quantity"
            title="Quantidade"
            stackProps={{ w: '1/4' }}>
            <Stack pr={Spacing['inline.xxxs']} w="full">
              <UI.InputStepper
                stepperValue={0.01}
                max={1000000}
                min={offer.minimumStepQuantity || 0}
                name="treasury-amount-order-input"
                keyboardType="numeric"
                defaultValue={amountItem || 0}
                onChange={handleChangeAmountItem}
                showErrorMessage={false}
              />
            </Stack>
          </UI.ListItem>
          <UI.ListItem
            testId="selected-product-value"
            title="Valor a aplicar"
            stackProps={{ w: '3/5' }}>
            <Stack pr={Spacing['inline.xxxs']} w="full">
              <InputMoney
                id={`directTreasury-input${id}`}
                name="priceItem"
                control={control}
                handleFocus={handleInputFocus}
                handleBlur={handleInputBlur}
                handleSubmit={handleSubmit}
                handleClear={handleInputClear}
                currentValue={currentValueFormatted}
                hasFocus={isFocused}
                minValue={offer.minimumApplication || 0}
                customInputProps={{
                  ...{
                    ...(showMessageAdjustUnitPrice && {
                      helpTextProps,
                      helpText,
                    }),
                  },
                  ...{ ...(isFocused && hasError && { error: hasError }) },
                  ...{ ...(isFocused && !hasError && { helpText }) },
                }}
              />
            </Stack>
          </UI.ListItem>
          <ResponsiveSuccessIconButton />
        </HStack>
      </VStack>
    </Box>
  );
};
